'use client';

import dynamic from 'next/dynamic';
import { css } from '@emotion/react';
import { useThemeMode } from '@/context';
import { responsive, ScrollToTop } from '@wci-tech/core-ui';

const WhatsAppConnect = dynamic(() => import('@/components/whatsAppConnect/WhatsAppConnect'), {
  ssr: false,
  loading: () => null,
});

export default function HomeClientWidgets() {
  const { isDark } = useThemeMode();

  return (
    <>
      <WhatsAppConnect />
      <ScrollToTop
        iconSize={16}
        backgroundColor={isDark ? '#212121' : '#FAFAFA'}
        customStyles={css`
          outline: 4px solid ${isDark ? '#212121' : '#FAFAFA'};
          ${responsive.create({
            width: { default: '40px', md: '40px', lg: '50px' },
            minWidth: { default: '40px', md: '40px', lg: '50px' },
            height: { default: '40px', md: '40px', lg: '50px' },
          })}
        `}
      />
    </>
  );
}
